goog.provide("shadow.js.shim.module$react_bootstrap$Tooltip$default");
shadow.js.shim.module$react_bootstrap$Tooltip$default = shadow.js.require(210, {})["default"];
